import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[msNavContent]',
  standalone: true
})
export class SplitNavContentDirective {
  @Input('msNavContent') tabId!: string;

  constructor(public template: TemplateRef<any>) {}
}
